import { Capacitor } from '@capacitor/core';
import { isCrawler } from './authentication';
import { useScript } from './utils';

const useCookieConsent = () => {
  const [cookieLoaded] = useScript(
    Capacitor.isNativePlatform() || isCrawler() || window.location.hostname === 'localhost'
      ? undefined
      : 'https://cdn.cookie-script.com/s/b30e7acdceb92c9c217d50a96acde05a.js',
  );

  return { cookieLoaded };
};

export default useCookieConsent;
